define('app/dashboard/widgets/PieChartDashboardItemView',['require','./ReportDashboardItemView','app/app','app/visualizations/PieChart','hbs!./PieChartDashboardItemView.hbs'],function(require) {

	'use strict';

	var ReportDashboardItemView = require('./ReportDashboardItemView'),
		APP = require('app/app'),
		PieChart = require('app/visualizations/PieChart');

	var DashboardPieChart = PieChart.extend({
		getChartOptions: function(data) {
			var self = this,
				report = this.options.model,
				options,
				dashboard = {},
				layout;

			if (APP && APP.dashboards) {
				dashboard = APP.dashboards.find(function(d) {
					return d.id === report.get('dashboardId');
				});
			}

			layout = dashboard.get('layout') && dashboard.get('layout').toUpperCase();

			if (layout === 'DECISION') {
				self.type = 'donut';

				options = {
					c3: {
						data: {
							type: this.type,
							columns: data,
							onclick: function(d) {
								self.onClickChart(d);
							}
						},
						legend: {
							show: false,
							hide: true
						},
						grid: {
							x: {
								show: false
							},
							y: {
								show: false
							}
						},
						axis: {
							x: {
								shown: false
							},
							y: {
								shown: false
							}
						},
						padding: {
							top: 0,
							right: 0,
							bottom: 0,
							left: 0
						},
						donut: {
							label: {
								show: false
							},
							width: 40
						},
						size: {
							width: 155,
							height: 155
						},
						color: {
							pattern: (function() {
								var output = [];
								for (var i = 0; i < data.length; i++) {
									switch (data[i][0]) {
										case 'ACCEPT':
										case 'Auto-Approved':
											output.push('#8cb566');
											break;
										case 'DECLINE':
										case 'AUTO_DECLINED':
											output.push('#ac353b');
											break;
										case 'KBA_DECLINED':
											output.push('#cb8184');
											break;
										case 'ERROR':
											output.push('#de8332');
											break;
										case 'INCONCLUSIVE':
											output.push('#f9b317');
											break;
										case 'REVIEW':
										case 'Sent for Review':
											output.push('#81add8');
											break;
										default:
											output.push('#cccccc');
									}
								}
								return output;
							}())
						}
					}
				};
			} else if (layout === 'MARKETING') {
				self.type = 'donut';

				options = {
					c3: {
						data: {
							type: this.type,
							columns: data,
							onclick: function(d) {
								self.onClickChart(d);
							}
						},
						legend: {
							show: false,
							hide: true
						},
						grid: {
							x: {
								show: false
							},
							y: {
								show: false
							}
						},
						axis: {
							x: {
								shown: false
							},
							y: {
								shown: false
							}
						},
						padding: {
							top: 0,
							right: 0,
							bottom: 0,
							left: 0
						},
						donut: {
							label: {
								show: false
							},
							width: 59
						},
						size: {
							width: 186,
							height: 186
						},
						color: {
							pattern: (function() {
								return [
									// Set 1
									'#336699', '#56812b', '#9b598a', '#3d807d', '#003265', '#816e59', '#69747b', '#776f96', '#58595b', '#1a892f',
									// Set 2
									'#5591b1', '#659941', '#7f9fb4', '#45a9a4', '#8c4755', '#a0c1e0', '#408068', '#ac6d9b', '#326598', '#a3b43b',
									// Set 3
									'#3898ae', '#715893', '#87a545', '#4372aa', '#dd8332', '#45a3d8', '#e1c321', '#9a247e', '#91a7d0', '#ae4742',
									// Set 4
									'#007ba3', '#a3b43b', '#f9b317', '#408068', '#43adda', '#8c4755', '#99ab7e', '#afdfe4', '#c644ba', '#91a7d0'
								];
							}())
						}
					}
				};
			} else if (layout === 'FUNDING') {
				self.type = 'donut';

				options = {
					c3: {
						data: {
							type: this.type,
							columns: data,
							onclick: function(d) {
								self.onClickChart(d);
							}
						},
						size: {
							width: 250,
							height: 250
						},
						padding: {
							top: 25
						}
					}
				};
			} else {
				options = {
					c3: {
						size: {
							height: this.height || this.$el.height(),
							width: this.width
						},
						legend: {
							position: 'right',
							show: this.showLegend
						},
						data: {
							type: this.type,
							columns: data,
							onclick: function(d) {
								self.onClickChart(d);
							}
						},
						padding: {
							top: this.paddingTop,
							right: this.paddingRight,
							bottom: this.paddingBottom,
							left: this.paddingLeft
						}
					}
				};
			}

			if (this.fixToolTips) {
				options.c3.tooltip = {
					position: function() {
						return {
							top: 0,
							left: 0
						};
					}
				};
			}

			return options;
		}
	});

	return ReportDashboardItemView.extend({
		className: 'dashboard-item dashboard-item-pie-chart',
		template: require('hbs!./PieChartDashboardItemView.hbs'),

		initialize: function() {
			// call base class initialize function
			ReportDashboardItemView.prototype.initialize.call(this);

			this.model.set('isLoading', true);
			this.listenTo(this.model, 'dataReceived', this.dataReceived);
			this.listenTo(this.model, 'change', this.render);
		},

		regions: {
			chartContainer: '.pie-chart-container'
		},

		onRender: function() {
			this.chartView = new DashboardPieChart({
				model: this.model,
				height: 300,
				width: 300,
				showLegend: false,
				showSubchart: false,
				showTicks: false,
				fixToolTips: true,
				paddingRight: 5,
				paddingLeft: 5
			});

			this.chartContainer.show(this.chartView);
		},

		dataReceived: function() {
			this.model.set('isLoading', false);
			this.render();
		},

		isLoading: function() {
			return this.model.get('isLoading');
		},

		onClose: function() {
			if (this.chartView) {
				this.chartView.close();
			}

			this.remove();
			this.unbind();
			this.model.unbind('change', this.modelChanged);
		}
	});
});

